module.exports = __webpack_public_path__ + "media/react/assets/EmployeeWithoutGoal-0a2cb22e7dedc43bb7937b0165839e5c.svg";